import { render } from "./xlptdetail.vue?vue&type=template&id=277c3f4e&scoped=true&ts=true"
import script from "./xlptdetail.vue?vue&type=script&lang=ts"
export * from "./xlptdetail.vue?vue&type=script&lang=ts"

import "./xlptdetail.vue?vue&type=style&index=0&id=277c3f4e&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277c3f4e"]])

export default __exports__